import { render, staticRenderFns } from "./PointReward.vue?vue&type=template&id=290ac62a&scoped=true"
import script from "./PointReward.vue?vue&type=script&lang=js"
export * from "./PointReward.vue?vue&type=script&lang=js"
import style0 from "./PointReward.vue?vue&type=style&index=0&id=290ac62a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290ac62a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('290ac62a')) {
      api.createRecord('290ac62a', component.options)
    } else {
      api.reload('290ac62a', component.options)
    }
    module.hot.accept("./PointReward.vue?vue&type=template&id=290ac62a&scoped=true", function () {
      api.rerender('290ac62a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/PageDecoration/PreviewArea/PointReward.vue"
export default component.exports